import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./CSS/LeftPart.css";
import tringle from "../Assets/Triangle-Exclamation-Point.jpg";
import dashboard from "../Assets/8929999.png";
import system from "../Assets/3318006-200.png";
import cold_heat from "../Assets/5027602.png";
import air_co from "../Assets/9303321.png";
import pump from "../Assets/5735563.png";
import elec_gen from "../Assets/3118156.png";
import steam from "../Assets/3205066.png";
import electric from "../Assets/252851.png";
import analy from "../Assets/2041637.png";
import light from "../Assets/566359.png";
import logo from "../Assets/IMG-20230407-WA0001_transparent.png";
import { connect } from "react-redux";
import others from "../Assets/7216130.png";
import { getCurrentPageDomain } from "../Reducer/Reducer";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Store from "../Store/Store";
import {
  CLEAR_COMPANY_ID,
  clear_email,
  clear_uid,
  set_current_dyn_pageName,
  set_system_moni_control,
  set_username,
  setTesis,
} from "../Action/Action";
import AydinlatmaIcon from "../Assets/Icons/Aydinlatma.png";
import BuharKazaniIcon from "../Assets/Icons/BuharKazani.png";
import DashboardpngIcon from "../Assets/Icons/Dashboard.png";
import Misafir_Oda from "../Assets/Icons/pngwing.com.png";
import water_storage from "../Assets/Icons/tank.png";
import DigerSistemlerIcon from "../Assets/Icons/DigerSistemler.png";
import EnerjiIcon from "../Assets/Icons/Enerji.png";
import IsitmaSistemleriIcon from "../Assets/Icons/IsitmaSistemleri.png";
import KlimaSantIcon from "../Assets/Icons/KlimaSant.png";
import NotificationsIcon from "../Assets/Icons/Notifications.png";
import PompaVeHidroforIcon from "../Assets/Icons/PompaVeHidrofor.png";
import RooftopIcon from "../Assets/Icons/Rooftop.png";
import SogutmaSistemleriIcon from "../Assets/Icons/SogutmaSistemleri.png";
import SystemMonitoringIcon from "../Assets/Icons/SystemMonitoring.png";
import TuketimTakibiIcon from "../Assets/Icons/TuketimTakibi.png";
import VRFIcon from "../Assets/Icons/VRF.png";
import WorkOrdersIcon from "../Assets/Icons/WorkOrders.png";
import DevicesIcon from "../Assets/Icons/Devices.png";
import TagsIcon from "../Assets/Icons/Tags.png";
import { useLocation } from "react-router-dom";
import pageService from "./AxisScada/services/pageService";

// Icon name/path to imported icon mapping for SCADA pages
const getPageIconSrc = (pageIcon) => {
  if (!pageIcon) return null;

  // Map icon names or paths to imported icons
  const iconMap = {
    'Dashboard': DashboardpngIcon,
    'TuketimTakibi': TuketimTakibiIcon,
    'PompaVeHidrofor': PompaVeHidroforIcon,
    'IsitmaSistemleri': IsitmaSistemleriIcon,
    'SogutmaSistemleri': SogutmaSistemleriIcon,
    'Enerji': EnerjiIcon,
    'VRF': VRFIcon,
    'KlimaSant': KlimaSantIcon,
    'Rooftop': RooftopIcon,
    'tank': water_storage,
    'BuharKazani': BuharKazaniIcon,
    'Aydinlatma': AydinlatmaIcon,
    'DigerSistemler': DigerSistemlerIcon,
    'SystemMonitoring': SystemMonitoringIcon,
    'Notifications': NotificationsIcon,
    'Devices': DevicesIcon,
    'Tags': TagsIcon,
  };

  // Direct match by name
  if (iconMap[pageIcon]) return iconMap[pageIcon];

  // Extract icon name from /static/media/ path
  // e.g., "/static/media/VRF.b74b0ba4ac8e6f9de3c7.png" -> "VRF"
  if (pageIcon.includes('/static/media/')) {
    const match = pageIcon.match(/\/static\/media\/([^.]+)\./);
    if (match && iconMap[match[1]]) {
      return iconMap[match[1]];
    }
  }

  return null;
};

const LeftPart = (props) => {
  const history = useHistory();
  const location = useLocation();

  const [pages_list, Set_Pages_List] = useState([]);

  const [pages_names_, Set_Pages_Names] = useState(props.pages_names);

  const [yetkilendirme_state, Set_yetkilendirme_state] = useState([]);

  const [iletişim, Set_iletişim] = useState(false);
  const [kullanıcı_Paneli, Set_kullanıcı_Paneli] = useState(false);
  const [raporlama, Set_raporlama] = useState(false);
  const [misafir_oda, Set_misafir_oda] = useState(false);

  const [vrf_control, Set_vrf_control] = useState(false);
  const [su_depoları, Set_su_depoları] = useState(false);
  const [enerji_izleme, Set_enerji_izleme] = useState(false);
  const [fanlar, Set_fanlar] = useState(false);
  const [sıcak_su, Set_sıcak_su] = useState(false);
  const [dashboard, Set_dashboard] = useState(false);

  const [pompa_hidrofor, Set_pompa_hidrofor] = useState(false);
  const [page_management, Set_page_management] = useState(false);
  const [template_management, Set_template_management] = useState(false);
  const [program_control, Set_program_control] = useState(false);
  const [scada_pages, Set_scada_pages] = useState(false); // SCADA menu - only visible for companyId=2
  const [scadaHomePage, setScadaHomePage] = useState(null); // SCADA homepage for current company
  const [scadaPagesList, setScadaPagesList] = useState([]); // SCADA pages list for Sistem İzleme

  // Load SCADA homepage and pages list when company changes
  useEffect(() => {
    const loadScadaData = async () => {
      try {
        // Load homepage
        const homepage = await pageService.getHomePage();
        if (homepage) {
          setScadaHomePage(homepage);
        }
        // Load pages list for Sistem İzleme
        const pages = await pageService.list();
        if (pages && pages.length > 0) {
          // Filter out test pages
          const filteredPages = pages.filter(p =>
            p.isActive !== false &&
            !p.pageName?.includes('🧪') &&
            !p.pageName?.includes('Test')
          );
          setScadaPagesList(filteredPages);
        }
      } catch (error) {
        console.error('Failed to load SCADA data:', error);
      }
    };
    loadScadaData();
  }, [props.temp_com_id]); // Reload when company changes

  useEffect(() => {
    // SCADA Sistemi artık yetki sisteminden kontrol ediliyor
    const userCompanyId = sessionStorage.getItem("user_companyId");
    // companyId=2 için varsayılan olarak SCADA açık (yetki ile kapatılabilir)
    // Diğer company'ler için varsayılan olarak kapalı
    const companyNum = Number(userCompanyId) || 0;
    const isCompany2 = companyNum === 2;
    Set_scada_pages(isCompany2); // companyId=2 için varsayılan açık

    props.users_list.forEach(x => {

      if (x.userId === props.auth_reducer && x.yetkilendirme) {
        let yetki_parse = JSON.parse(x.yetkilendirme)
        let com_id = props.temp_com_id || 1  // Use actual company ID from TEMPCOM (default: Akra V)
        let is_objectExist = yetki_parse[com_id]
        if (is_objectExist !== undefined) {
          Object.entries(is_objectExist).forEach(s => {
            if (s[0] === "İletişim") {
              if (s[1].O === "t") {
                Set_iletişim(true);
              } else {
                Set_iletişim(false);
              }
            } else if (s[0] === "Misafir-Oda") {
              if (s[1].O === "t") {
                Set_misafir_oda(true);
              } else {
                Set_misafir_oda(false);
              }
            } else if (s[0] === "Template_Management") {
              if (s[1].O === "t") {
                Set_template_management(true);
              } else {
                Set_template_management(false);
              }
            } else if (s[0] === "Page_Management") {
              if (s[1].O === "t") {
                Set_page_management(true);
              } else {
                Set_page_management(false);
              }
            } else if (s[0] === "Program") {
              // Program sadece companyId=2 (RMMS) kullanıcılarına görünür
              if (s[1].O === "t" && userCompanyId === "2") {
                Set_program_control(true);
              } else {
                Set_program_control(false);
              }
            } else if (s[0] === "Raporlama") {
              if (s[1].O === "t") {
                Set_raporlama(true);
              } else {
                Set_raporlama(false);
              }
            } else if (s[0] === "Kullanıcı Paneli") {
              if (s[1].O === "t") {
                Set_kullanıcı_Paneli(true);
              } else {
                Set_kullanıcı_Paneli(false);
              }
            } else if (s[0] === "VRF") {
              if (s[1].O === "t") {
                Set_vrf_control(true);
              } else {
                Set_vrf_control(false);
              }
            } else if (s[0] === "Sıcak Su") {
              if (s[1].O === "t") {
                Set_sıcak_su(true);
              } else {
                Set_sıcak_su(false);
              }
            } else if (s[0] === "Su Depoları") {
              if (s[1].O === "t") {
                Set_su_depoları(true);
              } else {
                Set_su_depoları(false);
              }
            } else if (s[0] === "Pompa/Hidrofor") {
              if (s[1].O === "t") {
                Set_pompa_hidrofor(true);
              } else {
                Set_pompa_hidrofor(false);
              }
            } else if (s[0] === "Fanlar") {
              if (s[1].O === "t") {
                Set_fanlar(true);
              } else {
                Set_fanlar(false);
              }
            } else if (s[0] === "Enerji İzleme") {
              if (s[1].O === "t") {
                Set_enerji_izleme(true);
              } else {
                Set_enerji_izleme(false);
              }
            } else if (s[0] === "Dashboard") {
              if (s[1].O === "t") {
                Set_dashboard(true);
              } else {
                Set_dashboard(false);
              }
            } else if (s[0] === "SCADA_Sistemi") {
              // SCADA Sistemi sadece companyId=2 kullanıcıları için
              // Varsayılan açık, yetki "f" ise kapatılır
              if (isCompany2) {
                if (s[1].O === "f") {
                  Set_scada_pages(false);
                } else {
                  Set_scada_pages(true);
                }
              }
            }
          }
          );
        }
      }
    })
  }, [props.auth_reducer, props.tag_ids, props.temp_com_id]);

  useEffect(() => {
    Set_Pages_Names(props.pages_names);
  }, [props.pages_names]);

  useEffect(() => {
    if (location.pathname.includes("/")) {
      Set_bar_Active(true);
    }
  }, [location]);

  const [bar_active, Set_bar_Active] = useState(false);

  return (
    <aside className="aside-left-bar">
      <div className="kapsayici-left-bar-div">
        <div className="top-part-left-bar">
          <div className="ust-yuvarlak-sx1">
            <div className="ust-yuvarlak-sx-2">
              <div className="ust-yuvarlak-sx-3">
                <div className="ust-yuvarlak-sx-4">
                  <img src={logo} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="firma-ad-left-bar">
            <Link
              style={{
                color: "black",
                textDecoration: "none",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginRight: "12px",
              }}
              to="/"
            >
              RMMS Kontrol Platformu
            </Link>
          </div>
        </div>
        <div className="links-and-left-nav-bar">
          <div className="login-part-left">
            <h3>Kullanıcı</h3>

            {props.ucer_id === 1 && (
              <div className="login-group-links">
                <Link
                  to="/TesisSec"
                  onClick={async () => {
                    sessionStorage.removeItem("Tesis")
                    await Store.dispatch(setTesis({ Akra: "" }));
                    setTimeout(() => {
                      window.location.reload();
                    }, 500);
                  }}
                  className="link-group-login-links"
                >
                  <i className="fa-solid fa-industry"></i>Tesisler
                </Link>
              </div>
            )}

            {/* Bağlantı Durumu - sadece companyId=2 kullanıcıları için */}
            {sessionStorage.getItem("user_companyId") === "2" && (
              <div className="login-group-links">
                <Link
                  to="/ConnectionStatus"
                  className="link-group-login-links"
                >
                  <i className="fa-solid fa-signal"></i>Bağlantı Durumu
                </Link>
              </div>
            )}
          </div>
          <div className="data-science-part">
            <h3>İzleme  </h3>

            <div className="link-group-data">
              <div
                className="link-group-data-links"
                onClick={() => {
                  // CompanyId 1 ve 2 için eski Ana Ekran, diğerleri için SCADA Homepage
                  const companyId = parseInt(sessionStorage.getItem("TEMPCOM") || sessionStorage.getItem("ucer_id") || "0");
                  if (companyId > 2 && scadaHomePage && scadaHomePage.pageId) {
                    history.push(`/axisPreview/${scadaHomePage.pageId}`);
                  } else {
                    history.push('/');
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <img
                  src={DashboardpngIcon}
                  className="fa-desktop"
                  alt="Dashboard"
                />
                Ana Ekran
              </div>
              <Link
                style={{ display: misafir_oda ? "flex" : "none" }}
                to={"/misafir_oda"}
                className="link-group-data-links"
              >
                <img src={Misafir_Oda} className="fa-desktop" alt="Dashboard" />
                Misafir-Oda Giriş
              </Link>
              <div
                onClick={(e) => {
                  var cont = !props.sistem_izleme_control;
                  Set_bar_Active(cont);
                  Store.dispatch(set_system_moni_control(cont));
                }}
                id="system_mony"
                className="link-group-data-links"
              >
                <img
                  src={SystemMonitoringIcon}
                  alt="System Monitoring"
                  className="fa-solid fa-desktop"
                />
                Sistem İzleme{" "}
                <i
                  className={`fa ${bar_active ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  style={{ marginLeft: "15px" }}
                ></i>
              </div>

              <div className="hidden_parent-Bar">
                {props.sistem_izleme_control === true ? (
                  <div>
                    {/* CompanyId 1 ve 2 için DynaPages, diğerleri için SCADA Pages */}
                    {/* CompanyId > 2 için SCADA Pages */}
                    {(() => {
                      const companyId = parseInt(sessionStorage.getItem("TEMPCOM") || sessionStorage.getItem("ucer_id") || "0");
                      if (companyId > 2) {
                        return scadaPagesList.map((page) => {
                          const pageId = page.id || page.pageId;
                          if (scadaHomePage && pageId === scadaHomePage.pageId) {
                            return null;
                          }
                          const displayName = (page.pageName || page.name || 'Sayfa').replace(/_/g, ' ');
                          const pageIcon = page.pageIcon || page.PageIcon || '';
                          const iconSrc = getPageIconSrc(pageIcon);
                          return (
                            <Link
                              key={pageId}
                              to={`/axisPreview/${pageId}`}
                              className="link-group-data-links"
                            >
                              {iconSrc ? (
                                <img
                                  src={iconSrc}
                                  alt={displayName}
                                  style={{ marginLeft: "40px", width: "32px", height: "32px", marginRight: "10px", verticalAlign: "middle" }}
                                />
                              ) : (
                                <i
                                  className={'fa fa-tv'}
                                  style={{ marginLeft: "50px", marginRight: "10px" }}
                                ></i>
                              )}
                              {displayName}
                            </Link>
                          );
                        });
                      }
                      return null;
                    })()}
                    {/* CompanyId 1 ve 2 için eski menü öğeleri */}
                    {dashboard && (
                      <Link
                        to={"/dashboard"}
                        className="link-group-data-links"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <img
                          src={TuketimTakibiIcon}
                          style={{ marginLeft: "45px", scale: "1.5" }}
                          alt="Soğutma Sistemleri"
                        />
                        Dashboard
                      </Link>
                    )}
                    {sıcak_su && (
                      <Link
                        to={"/hot_water_system"}
                        className="link-group-data-links"
                      >
                        <img
                          src={IsitmaSistemleriIcon}
                          style={{ marginLeft: "45px", scale: "1.5" }}
                          alt="Isıtma Sistemleri"
                        />
                        Sıcak Su Sistemi
                      </Link>
                    )}
                    {vrf_control && (
                      <Link
                        disabled={true}
                        className="link-group-data-links"
                        to={"/VRF"}
                      >
                        <img
                          src={VRFIcon}
                          style={{ marginLeft: "45px", scale: "1.5" }}
                          alt="VRF Icon"
                        />
                        VRF Sistemler ve Split Klimalar
                      </Link>
                    )}
                    {pompa_hidrofor && (
                      <Link
                        to={"/pumps_system"}
                        className="link-group-data-links"
                      >
                        <img
                          src={PompaVeHidroforIcon}
                          style={{ marginLeft: "45px", scale: "1.5" }}
                          alt="Pompa Ve Hidrofor Sistemler"
                        />
                        Pompa ve Hidrofor Sistemler
                      </Link>
                    )}
                    {fanlar && (
                      <Link to={"/fans"} className="link-group-data-links">
                        <i
                          style={{ marginLeft: "50px", scale: "1" }}
                          className="fa-solid fa-fan"
                        ></i>
                        Fanlar
                      </Link>
                    )}
                    {enerji_izleme && (
                      <Link to={"/energy"} className="link-group-data-links">
                        <img
                          src={EnerjiIcon}
                          style={{ marginLeft: "45px", scale: "1.5" }}
                          alt="Enerji"
                        />
                        Enerji İzleme{" "}
                      </Link>
                    )}
                    {su_depoları && (
                      <Link
                        to={"/su_depolari"}
                        className="link-group-data-links"
                      >
                        <img
                          src={water_storage}
                          style={{ marginLeft: "45px", scale: "0.95" }}
                          alt="Enerji"
                        />
                        Su Depoları{" "}
                      </Link>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {/* {props.pages_names.map((item, index) => {
                                var returnString = item
                                returnString = returnString.toLowerCase()
                                returnString = returnString.replace(/ö/g, 'o');
                                returnString = returnString.replace(/ç/g, 'c');
                                returnString = returnString.replace(/ş/g, 's');
                                returnString = returnString.replace(/ı/g, 'i');
                                returnString = returnString.replace(/ğ/g, 'g');
                                returnString = returnString.replace(/ü/g, 'u');
                                return <Link onClick={() => {

                                }} to={`/dashboard/${returnString.replaceAll(" ", "_")}`} className='link-group-data-links'><img src={analy} alt="" />{item}</Link>
                            })} */}
              </div>
              <div className="system-mon"></div>
              {raporlama ? (
                <Link
                  to={"/raporlama"}
                  style={{ marginRight: "0px" }}
                  className="link-group-data-links"
                >
                  <i className="fa-solid fa-list"></i> Raporlama
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* İLETİŞİM - Hidden */}
          {false && iletişim ? (

            <div className="communication-part">
              <h3>İLETİŞİM</h3>
              <div className="link-group-com">
                <Link to={"/deleteLogs"}>
                  <i
                    style={{
                      scale: "1.5",
                      marginLeft: "0.8rem",
                      width: "1.7rem",
                    }}
                    className="fa fa-times"
                  ></i>{" "}
                  TagLog Sil
                </Link>
                <Link to={"/communication/channel"}>
                  <img
                    src={DevicesIcon}
                    className="com-img"
                    style={{ marginRight: "20px" }}
                    alt="Kanal Icon"
                  />{" "}
                  Kanal
                </Link>
                <Link to={"/communication/tag"}>
                  <img
                    src={TagsIcon}
                    className="com-img"
                    style={{ marginRight: "20px" }}
                    alt="Tag Icon"
                  />{" "}
                  Tag
                </Link>
              </div>
            </div>) : (
            ""
          )}
          {/* SAYFA YÖNETİMİ - Hidden */}
          {false && (program_control || template_management || page_management) ? <div className="communication-part page-management-header">
            <h3>SAYFA YÖNETİMİ</h3>
            <div className="link-group-com">
              {page_management && <Link
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  width: "172px",
                }}
                to={"/pages_management"}
                className="link-group-data-links"
              >
                <i
                  className="fa-solid fa-circle-exclamation"
                  style={{ scale: 1.25 }}
                ></i>{" "}
                Page Management
              </Link>}

              {program_control && <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  width: "172px",
                }}
                onClick={async () => {
                  let req_ = await fetch("https://app-rmmsapi.azurewebsites.net/api/person/Generate_token", {
                    headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/json"
                    },
                    method: "POST",
                    body: JSON.stringify({
                      "companyId": String(props.temp_com_id),
                      userId: props.auth_reducer
                    })
                  })

                  let response = await req_.json()


                  let token_ = null;

                  if (req_.status === 200) {
                    token_ = response.token;

                    window.open(`https://rmms-metis-engine.azurewebsites.net?token=${token_}`, "_blank")

                  }
                }}
                className="link-group-data-links"
              >
                <i
                  className="fa-solid fa-circle-exclamation"
                  style={{ scale: 1.25 }}
                ></i>{" "}
                Program
              </div>}
              {template_management && <Link
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  width: "172px",
                }}
                to={"/template_management"}
                className="link-group-data-links"
              >
                <i
                  className="fa-solid fa-circle-exclamation"
                  style={{ scale: 1.25 }}
                ></i>{" "}
                Widget Management
              </Link>}
            </div>
          </div> : ""}

          {/* PROGRAM - Only visible for companyId=2 */}
          {program_control && (
          <div className="communication-part page-management-header">
            <h3>PROGRAM</h3>
            <div className="link-group-com">
              <Link
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', width: '172px' }}
                to={"/tasks"}
                className="link-group-data-links"
              >
                <i className="fa-solid fa-list-check" style={{ scale: 1.1 }}></i>{" "}
                Task Yönetimi
              </Link>
              <Link
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', width: '172px' }}
                to={"/flow"}
                className="link-group-data-links"
              >
                <i className="fa-solid fa-diagram-project" style={{ scale: 1.1 }}></i>{" "}
                Workflow Tasarım
              </Link>
              {/* Trend Raporları menüden kaldırıldı */}
              <Link
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', width: '172px' }}
                to={"/code-editor"}
                className="link-group-data-links"
              >
                <i className="fa-solid fa-code" style={{ scale: 1.1 }}></i>{" "}
                Kod Editörü
              </Link>
              <Link
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', width: '172px' }}
                to={"/templates"}
                className="link-group-data-links"
              >
                <i className="fa-solid fa-layer-group" style={{ scale: 1.1 }}></i>{" "}
                Şablon Yönetimi
              </Link>
              <Link
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', width: '172px' }}
                to={"/services"}
                className="link-group-data-links"
              >
                <i className="fa-solid fa-cloud" style={{ scale: 1.1 }}></i>{" "}
                Web Servisleri
              </Link>
              <Link
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', width: '172px' }}
                to={"/datasources"}
                className="link-group-data-links"
              >
                <i className="fa-solid fa-database" style={{ scale: 1.1 }}></i>{" "}
                Veri Kaynakları
              </Link>
            </div>
          </div>
          )}

          {/* ✨ SCADA Menu Section */}
          {scada_pages ? (
            <div className="communication-part page-management-header">
              <h3>SCADA SİSTEMİ</h3>
              <div className="link-group-com">
                <Link
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                    width: "172px",
                  }}
                  to={"/axisPages"}
                  className="link-group-data-links"
                >
                  <i
                    className="fa-solid fa-table-list"
                    style={{ scale: 1.25 }}
                  ></i>{" "}
                  SCADA Sayfalar
                </Link>

                <Link
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                    width: "172px",
                  }}
                  to={"/axisPageDesigner"}
                  className="link-group-data-links"
                >
                  <i
                    className="fa-solid fa-pen-ruler"
                    style={{ scale: 1.25 }}
                  ></i>{" "}
                  Sayfa Tasarımcı
                </Link>

                <Link
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                    width: "172px",
                  }}
                  to={"/axisWidgets"}
                  className="link-group-data-links"
                >
                  <i
                    className="fa-solid fa-cube"
                    style={{ scale: 1.25 }}
                  ></i>{" "}
                  Widget Kütüphanesi
                </Link>
              </div>
            </div>
          ) : (
            ""
          )}

          {kullanıcı_Paneli ? (
            <div className="users-and-role-part">
              <h3>Kullanıcı Panel</h3>
              <div className="link-group-users">
                <Link to={"/user_management"}>
                  <i className="fa-solid fa-user fa-sm"></i> Kullanıcı Yönetim
                </Link>
                <Link to={"/role_management"}>
                  <i className="fa-solid fa-users rol-yonetimi"></i> Rol Yönetim
                </Link>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </aside>
  );
};
const MapStateToProps = (state) => {
  return {
    pages: state.project_reducer.pages,
    pages_names: state.project_reducer.pages_names,
    auth_reducer: state.auth_reducer.user_id,
    sistem_izleme_control: state.project_reducer.sistem_izleme_control,
    profile_infos: state.project_reducer.profile_infos,
    yetkilendirme_state: state.project_reducer.yetkilendirme_state,
    group_id: state.project_reducer.group_id,
    users_list: state.project_reducer.users_list,
    com_id: state.project_reducer.company_id,
    tag_ids: state.project_reducer.tag_ids,
    tesis: state.project_reducer.tesis,
    ucer_id: state.project_reducer.ucer_id,
    temp_com_id: state.project_reducer.temp_com_id

  };
};

export default connect(MapStateToProps)(LeftPart);
